import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import styled from 'styled-components';
//import { assets } from '../../assets';
import Presentation from '../../logic/redux/presentation';
import Button from '../buttons/button';
import { FormattedMessage, useIntl } from 'react-intl';
import config from '../../../config';
import './terms-of-use.css';
import { GraphqlOperations } from '../../logic/graphql/operations';
//import { accept_terms_of_use } from '../../logic/graphql/generated-operations/mutations/accept_terms_of_use';
import { useMutation } from 'urql';
import Auth from '../../logic/redux/auth';

const TermsOfUseModalContent = (props: { id: number; onClose: () => void }): JSX.Element => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const authToken = useSelector(Auth.select.selectAuthToken);
  //const [pageNumber, setPageNumber] = useState<number>(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [scroll, setScroll] = useState<{
    offsetHeight: number;
    scrollHeight: number;
    scrollTop: number;
  }>({ offsetHeight: 0, scrollHeight: 1, scrollTop: 0 });

  const acceptTermsOfUse = useMutation(
    GraphqlOperations.mutations.accept_terms_of_use.mutationString,
  )[1];

  const handleOkClick = (): void => {
    const variables = GraphqlOperations.mutations.accept_terms_of_use.createVars(props.id);
    acceptTermsOfUse(variables)
      .then((result) => {
        if (result && !result.error) {
          dispatch(Auth.actions.setAuthTokenAcceptTerms());
          dispatch(Presentation.actions.setShowModal(undefined));
          if (!authToken?.need_password_update) {
            dispatch(Auth.actions.setUserLoggedIn());
          }

          /*addToast(intl.formatMessage({ id: 'loginPage.toastMessages.changePasswordSuccess' }), {
            appearance: 'success',
            autoDismiss: true,
          });*/
        }
        return true;
      })
      .catch((err) => console.log(err));
    //dispatch(Presentation.actions.setShowModal(undefined));
  };

  /*const handleCancelClick = (): void => {
    dispatch(Presentation.actions.setShowModal(undefined));
  };*/

  const pdfHref = config.backend_url + '/termsofuse/' + props.id.toString() + '/' + intl.locale;

  return (
    <div className="flex flex-col w-3/4">
      <h2 className="mb-4">
        <FormattedMessage id={'termsOfUseModal.title'} />
      </h2>
      <section className="mb-5">
        {
          <a href={pdfHref} target="_blank" rel="noreferrer">
            <FormattedMessage id={'termsOfUseModal.title'} />
          </a>
        }
        {/*<h3 className="mb-4">
          <u>
            <FormattedMessage id={'termsOfUseModal.legalNoticeText'} />
          </u>
        </h3>*/}
      </section>
      {/*<section className="mb-5">
        <h3 className="mb-4">
          <u>
            <FormattedMessage id={'termsOfUseModal.legalNoticeText'} />
          </u>
        </h3>
      </section>*/}
      <div className="flex flex-row justify-content-between">
        <Button
          inactive={scroll.scrollTop + scroll.offsetHeight + 150 < scroll.scrollHeight}
          secondary={true}
          className=""
          onClick={handleOkClick}
        >
          <FormattedMessage id={'termsOfUseModal.okButton'} />
        </Button>
        <Button className="ml-auto" onClick={props.onClose}>
          <FormattedMessage id={'termsOfUseModal.cancelButton'} />
        </Button>
      </div>
    </div>
  );
};

export default TermsOfUseModalContent;
